<template>
<!-- ヘッダー: スタンダード -->
  <header :class="makeHeaderStdCSS()" :style="makeColor()" v-if="showModalStatus === 1">
    <!-- 左側 48px -->
    <a class="-button"
      :style="{'color': color.iconFr}"
      @click="close(1)">
      <span class="mdi mdi-close"></span>
    </a>
    <h2 class="-title">
      <span class="mdi mdi-message-text -right-4px"></span>
      ご訪問ありがとうございます
    </h2>
  </header>
  <!-- ヘッダー -->
  <header :class="makeHeaderCSS()" :style="makeColor()" v-else>
    <!-- チャット中 -->
    <div class="dt-header not-copy">
      <!-- 左側 48px -->
      <div class="left-menu">
        <a class="-button"
          :style="{'color': color.iconFr}"
          @click="backModal()">
          <span class="mdi mdi-chevron-left"></span>
        </a>
      </div>
      <!-- チャット画面 - センター 100% - 144px -->
      <div class="center-menu">
        <template v-if="targetModel === 'bot'">
          <img class="-icon" src="@/assets/template/robot.png" v-if="targetIcon==''">
          <img class="-icon" :src="targetIcon" v-if="targetIcon!=''"/>
          <div class="desc">
            <p class="-company">{{widgetData.companyName}}</p>
            <p class="-name">{{target}}</p>
          </div>
        </template>
        <template v-else>
          <img class="-icon" src="@/assets/template/team.png">
          <div class="desc">
            <p class="-company">{{widgetData.companyName}}</p>
            <p class="-name">スタッフ</p>
          </div>
        </template>
      </div>
      <!-- ロボの一覧 / カード一覧 - センター -->
      <div class="center-menu-select" v-if="showModalStatus === 1">
        <p v-if="!search" class="select-conv-title">{{tabName}}</p>
        <p v-if="search" class="select-conv-title">検索結果</p>
      </div>
      <!-- 右側 - チャット画面のみ 96px -->
      <div
        class="right-menu"
        :style="{'color': color.iconFr}">
        <a
          @click="initScenario()"
          class="-button"
          v-if="showModalStatus === 2">
          <span class="mdi mdi-home-outline" :style="{'color': color.iconFr}"></span>
        </a>
        <a
          @click="close(1)"
          class="-button"
          v-if="showModalStatus === 1">
          <span class="mdi mdi-close" :style="{'color': color.iconFr}"></span>
        </a>
        <a
          @click="setStep(1)"
          class="-button"
          v-if="showModalStatus === 2">
          <span class="mdi mdi-close" :style="{'color': color.iconFr}"></span>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true,
    },
    search: {
      type: Boolean,
      required: true
    },
    showModalStatus: {
      type: Number,
      required: true
    },
    target: {
      type: String,
      required: true
    },
    targetIcon: {
      type: String,
      required: true
    },
    targetModel: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    widgetData: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close (num) {
      this.$emit('close', num)
    },
    setStep (num) {
      this.$emit('setStep', num)
      this.close(1)
    },
    initScenario () {
      this.$emit('initScenario')
    },
    backModal () {
      this.$emit('backModal')
    },
    isMobile () {
      if (this.data.useragent.match(/(iPhone|iPod|Android.*Mobile)/i)) return true
      else return false
    },
    makeColor () {
      return {
        'background': this.color.iconBg + '!important',
        'background': 'linear-gradient(to right, ' + this.color.iconBg + 'AA' + ', ' + this.color.iconBg + ') !important',
        'color': this.color.iconFr + '!important'
      }
    },
    makeHeaderStdCSS () {
      if (this.isMobile()) {
        return 'std-header-mb'
      } else {
        return 'std-header'
      }
    },
    makeHeaderCSS () {
      if (this.isMobile()) {
        return '-header-mb'
      } else {
        return '-header'
      }
    },
  }
}
</script>

<style lang="scss" scoped>
// スタンダード以外のクラス
.-header {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 72px;
  background: rgba(0,0,0,0.7);
  color: white;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  .dt-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .-button {
      color: rgba(255, 255, 255, 0.6);
      font-size: 24px;
      margin-left: 13px;
    }
    .left-menu {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center-menu {
      display: flex;
      text-align: left;
      align-items: center;
      width: calc(100% - 144px);
      .-icon {
        width: 32px;
        height: 32px;
        background: white;
        border-radius: 50%;
        margin-right: 8px;
      }
      .desc {
        width: 100%;
        .-company {
          width: calc(100% - 32px);
          font-size: 12px;
          margin-left: 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .-name {
          width: calc(100% - 32px);
          font-size: 16px;
          margin-left: 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .center-menu-select {
      width: calc(100% - 48px);
      .select-conv-title {
        font-size: 20px;
        font-weight: 600;
        margin-left: 48px;
      }
    }
    .right-menu {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 12px;
    }
  }
}
.-header-mb {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 72px;
  background: rgba(0,0,0,0.7);
  color: white;
  .dt-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .-button {
      color: rgba(255, 255, 255, 0.6);
      font-size: 24px;
      margin-left: 13px;
    }
    .left-menu {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center-menu {
      display: flex;
      text-align: left;
      align-items: center;
      width: calc(100% - 144px);
      .-icon {
        width: 32px;
        height: 32px;
        background: white;
        border-radius: 50%;
        margin-right: 8px;
      }
      .desc {
        width: 100%;
        .-company {
          width: calc(100% - 32px);
          font-size: 12px;
          margin-left: 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .-name {
          width: calc(100% - 32px);
          font-size: 16px;
          margin-left: 8px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
    .center-menu-select {
      width: calc(100% - 48px);
      .select-conv-title {
        font-size: 20px;
        font-weight: 600;
        margin-left: 48px;
      }
    }
    .right-menu {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 12px;
    }
  }
}
// スタンダードクラス
.std-header {
  position: relative;
  margin: 0;
  height: 72px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  .-title {
    width: 100%;
    font-size: 17px;
    text-align: left;
  }
  .-button {
    position: absolute;
    top:   18px;
    right: 16px;
    font-size: 24px;
  }
}
.std-header-mb {
  position: relative;
  margin: 0;
  height: 72px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  .-title {
    width: 100%;
    font-size: 17px;
    text-align: left;
  }
  .-button {
    position: absolute;
    top:   18px;
    right: 16px;
    font-size: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/DialogHeader.vue